module.exports = __webpack_public_path__ + "static/media/0023.abd6b01c.jpg";